import * as Sentry from '@sentry/browser'
import { getEnvironment } from '../environment'

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://30cd8b6eb163196c72d7cfbb47739b51@o4508002763735040.ingest.us.sentry.io/4508683616059392',
    environment: getEnvironment(),
  })
}
